import React, { FC } from 'react';
import { Grid } from '@mui/material';
import { SingleQrTableEntry } from './SingleQrTableEntry';
import { IQrEntry, ISingleQrOperations } from './constants';

interface Props extends ISingleQrOperations {
  list: IQrEntry[];
}

export const QrList: FC<Props> = ({ list, ...rest }) => (
  <div className="p-0 sm:p-6">
    <Grid container spacing={2} columns={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 5 }}>
      {list.map((entry, i) => (
        <SingleQrTableEntry
          {...rest}
          entry={entry}
          key={`single-qrEntry-${i}`}
        />
      ))}
    </Grid>
  </div>
);
